import { Status } from "../../newLayout/page/components/Status/Status";

/**
 * Status cell for the Users ListView (badge only — actions live in the toolbar).
 */
export const UsersStatusCell = ({ order }) => {
  const statusLabel = order?.status || (order?.is_active ? "Active" : "Inactive");

  return (
    <td className="status">
      <Status statusName={statusLabel} />
    </td>
  );
};
